import $ from 'jquery';

var header;
var topMargin;
var wrap;
var placeholder;

function init() {
    header = $("#header");
    topMargin = 10;
    wrap = $("#wrap");

    $(window).scroll(onScroll);
    onScroll();
}

function onScroll() {
    if (typeof placeholder === 'undefined') {
        var placeholderCheck = $('.right-wrapper-placeholder');
        if (placeholderCheck.length > 0) {
            placeholder = placeholderCheck;
        }
        else {
            return;
        }
    }
    var distanceToTop = placeholder[0].getBoundingClientRect().top;
    var visible = placeholder.is(':visible');
    var headerHeight = header.height();
    var pinned = visible && (distanceToTop - headerHeight - topMargin) < 0;

    if (pinned) {
        wrap.addClass('pinned');
    } else {
        wrap.removeClass('pinned');
    }
}

$(function () {
    init();
});

export default { init };